export default {
  mixMode: 'Modo do Mix',
  referenceBudget: 'Orçamento de Referência ({unit})',
  grid: 'Grade de Orçamentos ({count} orçamentos)',
  notFound: 'Esta simulação de orçamento não existe ou foi excluída.',
  backToList: 'Voltar ao Simulador de Orçamento',
  stillRunning: '{done} de {total} orçamentos calculados. O detalhe abre quando todos os orçamentos estiverem prontos.'
}
